export const newsTags = [
  { id: 'all', label: '全部' },
  { id: 'film', label: '新片' },
  { id: 'photo', label: '写真' },
  { id: 'event', label: '活动' },
  { id: 'message', label: '消息' },
  { id: 'status', label: '近况' },
];

export const newsList = [
  {
    id: 'n1',
    tag: 'film',
    tagLabel: '新片',
    period: '近期',
    title: '新片方向的整理线索已更新',
    summary: '最新公开的作品方向已归入「新片速览」，按题材分类，并补充了观看顺序建议。',
  },
  {
    id: 'n2',
    tag: 'photo',
    tagLabel: '写真',
    period: '本季',
    title: '写真合集补充了色调分类',
    summary: '写真合集按色调与场景重新划分，方便按偏好筛选，并补充了各合集的浏览建议。',
  },
  {
    id: 'n3',
    tag: 'event',
    tagLabel: '活动',
    period: '阶段',
    title: '活动信息完成分类归档',
    summary: '线下活动、线上直播与合作联动已分类，内容以参与方式方向为主，具体安排以主办方为准。',
  },
  {
    id: 'n4',
    tag: 'message',
    tagLabel: '消息',
    period: '近期',
    title: '如何核对消息来源',
    summary: '新增核实方法说明，区分官方发布、媒体转述与二次加工内容，帮助降低误读概率。',
  },
  {
    id: 'n5',
    tag: 'status',
    tagLabel: '近况',
    period: '持续',
    title: '近况按三条线索汇总',
    summary: '把近况拆成作品、写真、活动三线，先给整体节奏，再给细分方向，便于持续跟进。',
  },
  {
    id: 'n6',
    tag: 'film',
    tagLabel: '新片',
    period: '阶段',
    title: '纪念企划整理条目补充',
    summary: '回顾类纪念企划新增条目，串联不同时期方向，适合当作整体风格入门。',
  },
  {
    id: 'n7',
    tag: 'photo',
    tagLabel: '写真',
    period: '阶段性',
    title: '影像合集增加城市漫游主题',
    summary: '以外景为主的影像合集加入新的主题分类，记录街景与日常片段，观感更轻松。',
  },
  {
    id: 'n8',
    tag: 'event',
    tagLabel: '活动',
    period: '阶段性',
    title: '粉丝应援企划整理说明',
    summary: '补充了应援类活动的常见形式与注意事项，参与细则请以主办方公布为准。',
  },
];